(() => {
  function eligibility(cart, config, now) {
    const gifts = cart.items.filter(item => Number(item.variant_id) === config.variantId);
    const subtotal = cart.items.filter(item => item.product_type !== 'Halloween Gift' && Number(item.variant_id) !== config.variantId).reduce((sum, item) => sum + item.original_line_price, 0);
    const active = now >= Date.parse(config.startsAt) && now < Date.parse(config.endsAt);
    return { gifts, subtotal, active, qualifies: active && cart.currency === 'USD' && subtotal >= config.threshold };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { eligibility }; return; }
  const element = document.getElementById('sss-halloween-config');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const root = config.root.replace(/\/?$/, '/');
  const nativeFetch = window.fetch.bind(window);
  let queue = Promise.resolve(), pending = 0, latest = null, failed = false, repaintPending = false;
  const isGift = item => Number(item.variant_id) === config.variantId;
  const money = (value, currency = 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(value / 100);
  async function json(url, options) {
    const response = await nativeFetch(url, { credentials: 'same-origin', cache: 'no-store', ...options });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }
  const getCart = () => json(root + 'cart.js');
  const post = (action, body) => json(root + 'cart/' + action + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  function enqueue(work) {
    pending++;
    document.documentElement.classList.add('sss-gift-busy');
    const result = queue.then(work);
    queue = result.catch(() => {}).finally(() => {
      pending--;
      if (!pending) document.documentElement.classList.remove('sss-gift-busy');
    });
    return result;
  }
  async function removeGifts(cart) {
    const updates = Object.fromEntries(cart.items.filter(isGift).map(item => [item.key, 0]));
    return Object.keys(updates).length ? post('update', { updates }) : cart;
  }
  async function reconcile() {
    let cart = await getCart(), changed = false;
    let state = eligibility(cart, config, Date.now());
    if (!state.qualifies && state.gifts.length) { cart = await removeGifts(cart); changed = true; }
    if (state.qualifies) {
      if (state.gifts.length !== 1 || state.gifts[0].quantity !== 1) {
        cart = await removeGifts(cart);
        try {
          await post('add', { items: [{ id: config.variantId, quantity: 1, properties: { _halloween_gift: '2026' } }] });
          cart = await getCart();
        } catch (error) {
          cart = await getCart();
          cart = await removeGifts(cart);
          latest = cart;
          failed = true;
          paint();
          throw error;
        }
        changed = true;
      }
      const gift = cart.items.find(isGift);
      if (!gift || gift.final_line_price !== 0) {
        cart = await removeGifts(cart);
        changed = true;
        failed = true;
      } else failed = false;
    } else failed = false;
    latest = cart;
    paint();
    return { cart, changed };
  }
  function paint() {
    if (!latest) return;
    const state = eligibility(latest, config, Date.now());
    const gift = state.gifts.find(item => item.final_line_price === 0 && item.quantity === 1);
    document.querySelectorAll('[data-halloween-offer]').forEach(box => {
      box.hidden = !state.active || latest.currency !== 'USD';
      const message = failed ? config.strings.error : gift ? config.strings.added : config.strings.remaining.replace('[amount]', money(Math.max(0, config.threshold - state.subtotal), latest.currency));
      const target = box.querySelector('[data-halloween-message]');
      if (target && target.textContent !== message) target.textContent = message;
      const summary = box.querySelector('[data-halloween-summary]');
      if (!summary) return;
      const signature = box.dataset.showGift && gift ? gift.key + ':' + gift.original_price : '';
      summary.hidden = !signature;
      if (summary.dataset.signature === signature) return;
      summary.dataset.signature = signature;
      summary.replaceChildren();
      if (signature) {
        const row = document.createElement('div'); row.className = 'sss-halloween-summary';
        const img = document.createElement('img'); img.src = gift.image; img.alt = config.strings.gift; img.width = 64; img.height = 64;
        const text = document.createElement('div');
        const name = document.createElement('div'); name.textContent = config.strings.gift;
        const design = document.createElement('div'); design.textContent = config.strings.random;
        const old = document.createElement('s'); old.textContent = money(gift.original_price, latest.currency);
        const price = document.createElement('strong'); price.textContent = money(gift.final_price, latest.currency);
        text.append(name, design, old, price); row.append(img, text); summary.append(row);
      }
    });
  }
  async function sections(ids, path = location.pathname) {
    if (!ids.length) return {};
    const url = new URL(path, location.origin);
    url.searchParams.set('sections', ids.slice(0, 5).join(','));
    return json(url.toString());
  }
  async function refresh() {
    const targets = [
      ['main-cart-items', document.getElementById('main-cart-items')?.dataset.id, '.js-contents'],
      ['main-cart-footer', document.getElementById('main-cart-footer')?.dataset.id, '.js-contents'],
      ['cart-icon-bubble', 'cart-icon-bubble', '.shopify-section'],
      ['CartDrawer', 'cart-drawer', '#CartDrawer']
    ].filter(([id, section]) => document.getElementById(id) && section);
    const html = await sections([...new Set(targets.map(item => item[1]))]);
    for (const [id, section, selector] of targets) {
      if (!html[section]) continue;
      const source = new DOMParser().parseFromString(html[section], 'text/html').querySelector(selector);
      const target = document.getElementById(id);
      if (source && target) (target.querySelector(selector) || target).innerHTML = source.innerHTML;
    }
    for (const target of document.querySelectorAll('cart-items, cart-drawer, #main-cart-footer')) target.classList.toggle('is-empty', latest.item_count === 0);
    paint();
  }
  window.fetch = function(input, init) {
    const url = new URL(typeof input === 'string' ? input : input.url || input.toString(), location.origin);
    const action = url.origin === location.origin && url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/)?.[1];
    if (!action) return nativeFetch(input, init);
    return enqueue(async () => {
      const response = await nativeFetch(input, init);
      if (!response.ok) return response;
      let payload;
      try { payload = await response.clone().json(); } catch { return response; }
      if (payload.errors || payload.status) return response;
      try {
        const result = await reconcile();
        if (action === 'add') {
          const match = item => result.cart.items.find(line => line.variant_id === item.variant_id && JSON.stringify(line.properties || {}) === JSON.stringify(item.properties || {}));
          if (payload.key && match(payload)) payload.key = match(payload).key;
          if (payload.items) payload.items = payload.items.map(item => ({ ...item, key: match(item)?.key || item.key }));
        }
        if (action !== 'add') payload = { ...result.cart, sections: payload.sections, _sssGiftReconciled: true };
        if (payload.sections) {
          const fresh = await sections(Object.keys(payload.sections));
          for (const [id, html] of Object.entries(fresh)) if (html !== null) payload.sections[id] = html;
        }
        requestAnimationFrame(paint);
        const headers = new Headers(response.headers);
        headers.delete('content-length'); headers.delete('content-encoding');
        return new Response(JSON.stringify(payload), { status: response.status, statusText: response.statusText, headers });
      } catch (error) {
        failed = true;
        paint();
        return response;
      }
    });
  };
  function sync() {
    return enqueue(async () => { const result = await reconcile(); if (result.changed) await refresh(); return result; }).catch(() => { failed = true; paint(); });
  }
  document.addEventListener('submit', event => {
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    enqueue(async () => {
      await reconcile();
      if (failed) { await refresh(); return; }
      location.assign(root + 'checkout');
    }).catch(() => { failed = true; paint(); });
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    enqueue(async () => { await reconcile(); if (!failed) location.assign(link.href); else await refresh(); }).catch(() => { failed = true; paint(); });
  }, true);
  const observer = new MutationObserver(() => {
    if (repaintPending) return;
    repaintPending = true;
    requestAnimationFrame(() => { repaintPending = false; paint(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) sync(); });
  setInterval(() => { if (!document.hidden && latest && latest.items.some(isGift) && Date.now() >= Date.parse(config.endsAt)) sync(); }, 30000);
  sync();
})();
